const all = [
  {
    key: "bag0001",
    id: "bag0001",
    name: "Coach Tyler",
    fullName: "Coach Tyler Carry All 28",
    url: "https://s7d2.scene7.com/is/image/Coach/c3460_b4bk_a0?$pd_main$",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    producedBy: "Coach Official Store",
    brand: "Coach",
    year: 2021,
    price: 1700,
    rating: 3,
    bcolor: "#EFEFEF",
    color: "black",
    quantity: 1,
  },
  {
    key: "bag0002",
    id: "bag0002",
    name: "CK Stitch Trim Saddle Bag",
    fullName: "Charles & Keith Stitch Trim Saddle Bag",
    url: "https://www.charleskeith.com/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-ck-products/default/dw92c27e11/images/hi-res/2021-L3-CK2-80151035-22-1.jpg?sw=1152&sh=1536",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 238.9,
    rating: 4,
    bcolor: "#ECECEC",
    color: "brown",
    quantity: 1,
  },
  {
    key: "bag0003",
    id: "bag0003",
    name: "CK Gabine Saddle Bag",
    fullName: "Charles & Keith Gabine Saddle Bag",
    url: "https://www.charleskeith.com/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-ck-products/default/dw189104e7/images/hi-res/2021-L2-CK2-80781412-13-1.jpg?sw=1152&sh=1536",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 279.9,
    rating: 5,
    bcolor: "#ECECEC",
    color: "pink",
    quantity: 1,
  },
  {
    key: "bag0006",
    id: "bag0006",
    name: "CK Double Handle Bag",
    fullName: "Charles & Keith Double Handle Shoulder Bag",
    url: "https://www.charleskeith.com/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-ck-products/default/dw94522437/images/hi-res/2021-L3-CK2-20671235-60-1.jpg?sw=1152&sh=1536",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 5,
    bcolor: "#ECECEC",
    color: "pink",
    quantity: 1,
  },
  {
    key: "bag0007",
    id: "bag0007",
    name: "CK Beaded Strap Ruched Shoulder Bag",
    fullName: "Charles & Keith Beaded Strap Ruched Shoulder Bag",
    url: "https://www.charleskeith.com/dw/image/v2/BCWJ_PRD/on/demandware.static/-/Sites-ck-products/default/dwa43af43d/images/hi-res/2021-L3-CK2-20270749-03-1.jpg?sw=1152&sh=1536",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "sneaker001",
    id: "sneaker001",
    name: "Nike Air Force 1 '07 sneakers",
    fullName: "Nike Air Force 1 '07 sneakers",
    url: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "sneaker002",
    id: "sneaker002",
    name: "Adidas UltraBoost 22 sneakers",
    fullName: "Adidas UltraBoost 22 sneakers",
    url: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=464&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "sneaker003",
    id: "sneaker003",
    name: "Adidas Originals Gazelle sneakers",
    fullName: "Adidas Originals Gazelle sneakers",
    url: "https://images.unsplash.com/photo-1605348532760-6753d2c43329?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "sneaker004",
    id: "sneaker004",
    name: "Puma Wild Rider rollin sneakers",
    fullName: "Puma Wild Rider rollin' sneakers",
    url: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "sneaker005",
    id: "sneaker005",
    name: "Jordan 4 Retro University Blue sneakers",
    fullName: "Jordan 4 Retro University Blue sneakers",
    url: "https://images.unsplash.com/photo-1618898909019-010e4e234c55?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Charles & Keith Official Store",
    brand: "Charles & Keith",
    year: 2021,
    price: 319.9,
    rating: 3,
    bcolor: "#ECECEC",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing001",
    id: "clothing001",
    name: "H&M Leggings & Cotton Leggings",
    fullName: "H&M Leggings With Brushed Inside",
    url: "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=405&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing002",
    id: "clothing002",
    name: "Under Armour Speed Stride Ss Sn14",
    fullName: "Under Armour Speed Stride Ss Sn14",
    url: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=436&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing003",
    id: "clothing003",
    name: "H&M Modern Long-Sleeved Shirt ",
    fullName: "H&M Modern Long-Sleeved Shirt",
    url: "https://images.unsplash.com/photo-1613480838954-10d9f4de0128?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing004",
    id: "clothing004",
    name: "Adidas Unisex Adults T Shirt",
    fullName: "Adidas Giant Logo Unisex Adults T Shirt",
    url: "https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing005",
    id: "clothing005",
    name: "Under Armour Tech Mesh Men's Shorts",
    fullName: "Under Armour Tech Mesh Men's Shorts",
    url: "https://images.unsplash.com/photo-1624378441864-6eda7eac51cb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=388&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing006",
    id: "clothing006",
    name: "Puma Performance Womman's Shorts",
    fullName: "Puma Performance Womman's Shorts",
    url: "https://images.unsplash.com/photo-1638394440667-aa54a7c0a703?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing007",
    id: "clothing007",
    name: "ADDYVERO Women's Slim Fit Casual Trousers",
    fullName: "ADDYVERO Women's Slim Fit Casual Trousers",
    url: "https://images.unsplash.com/photo-1590159983013-d4ff5fc71c1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "clothing008",
    id: "clothing008",
    name: "Levi's Women's Wedgie Icon Fit Jeans",
    fullName: "Levi's Women's Wedgie Icon Fit Jeans",
    url: "https://images.unsplash.com/photo-1578693082747-50c396cacd81?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "sport001",
    id: "sport001",
    name: "Xivaia Lepad Cricket Tennis Ball",
    fullName: "Xivaia Lepad Cricket Tennis Ball",
    url: "https://images.unsplash.com/photo-1574379989050-bfd9e1a8a543?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "sport002",
    id: "sport002",
    name: "Callaway Golf White Supersoft Golf Balls",
    fullName: "Callaway Golf White Supersoft Golf Balls",
    url: "https://images.unsplash.com/photo-1629673336910-d1bd313d669b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "sport003",
    id: "sport003",
    name: "NBA Spalding Neko Basketball Ball",
    fullName: "NBA Spalding Neko Basketball Ball",
    url: "https://images.unsplash.com/photo-1595861021888-e8192a7f774e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "sport004",
    id: "sport004",
    name: "MLS Club Soccer Ball 2021",
    fullName: "MLS Club Soccer Ball 2021",
    url: "https://images.unsplash.com/photo-1516567727245-ad8c68f3ec93?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=449&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "electronic001",
    id: "electronic001",
    name: "4k Samsung Smart Xepria Nitro TV",
    fullName: "4k Samsung Smart Xepria Nitro TV",
    url: "https://images.unsplash.com/photo-1577979749830-f1d742b96791?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "electronic002",
    id: "electronic002",
    name: "Macbook 13 Pro Max M1 16 inch",
    fullName: "Macbook 13 Pro Max M1 16 inch",
    url: "https://images.unsplash.com/photo-1585161973248-4f328217cb3a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "laptop",
    quantity: 1,
  },
  {
    key: "electronic003",
    id: "electronic003",
    name: "Apple Air Pods Pro Max",
    fullName: "Apple Air Pods Pro Max",
    url: "https://images.unsplash.com/photo-1591370264374-9a5aef8df17a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "electronic004",
    id: "electronic004",
    name: "I phone 13 pro max",
    fullName: "I phone 13 Pro Max",
    url: "https://images.unsplash.com/photo-1605236453806-6ff36851218e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=464&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "animal001",
    id: "animal001",
    name: "GoldenRetiver Dog",
    fullName: "GoldenRetiver Dog",
    url: "https://images.unsplash.com/photo-1552053831-71594a27632d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=362&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "animal002",
    id: "animal002",
    name: "German Xpe Cat",
    fullName: "German Xpe Cat",
    url: "https://images.unsplash.com/photo-1573865526739-10659fec78a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=415&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "animal003",
    id: "animal003",
    name: "Squrirrel Sprit",
    fullName: "Squrirrel Sprit",
    url: "https://images.unsplash.com/photo-1590079015089-875baa76cc8d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=464&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
  {
    key: "animal004",
    id: "animal004",
    name: "Golden Buffo Dog",
    fullName: "Golden Buffo Dog",
    url: "https://images.unsplash.com/photo-1633722715463-d30f4f325e24?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo dolores fugiat nulla, deleniti voluptatem aliquam doloribus vitae libero aperiam sint laborum dolor voluptas. Non, quia. Voluptatibus, provident! Et, temporibus accusantium!",
    producedBy: "Adidas Official Store",
    brand: "Adidas",
    year: 2021,
    price: 109,
    rating: 4,
    bcolor: "white",
    color: "white",
    quantity: 1,
  },
];
export default all;
